export const environment = {
    production: false,
    apiUrl: 'http://localhost:8030/api',
    appVersion: require('../../package.json').version + '-dev',
    appMode: 'lite',
    accountPort:'8068'

};
